import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { LocaleService } from "../../services/locale.service";
import * as i0 from "@angular/core";
import * as i1 from "../../services/locale.service";
import * as i2 from "./locale-selector-view.component";
import * as i3 from "@angular/common";
export class LocaleSelectorComponent {
    constructor(localeService) {
        this.localeService = localeService;
        this.showCountry = true;
        /**
         * can be 'full' or 'flagOnly'
         */
        this.displayMode = "full";
        this.selectedLocale = new EventEmitter();
        if (this.locales === undefined) {
            this.locales = this.localeService.availableLocales$.value
                ?.sort((la, lb) => la.index - lb.index)
                .map((locale) => locale.iso);
        }
    }
    async selectLocale(language) {
        await this.localeService.setCurrentLocale(language);
        this.selectedLocale.emit(language);
    }
}
LocaleSelectorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: LocaleSelectorComponent, deps: [{ token: i1.LocaleService }], target: i0.ɵɵFactoryTarget.Component });
LocaleSelectorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.2.5", type: LocaleSelectorComponent, selector: "smallstack-locale-selector", inputs: { locales: "locales", showCountry: "showCountry", menuClass: "menuClass", displayMode: "displayMode" }, outputs: { selectedLocale: "selectedLocale" }, ngImport: i0, template: "<locale-selector-view\n  [menuClass]=\"menuClass\"\n  [locale]=\"localeService.currentLocale$ | async\"\n  [locales]=\"locales\"\n  (change)=\"selectLocale($event)\"\n  [displayMode]=\"displayMode\"\n  [showCountry]=\"showCountry\"\n></locale-selector-view>\n", dependencies: [{ kind: "component", type: i2.LocaleSelectorViewComponent, selector: "locale-selector-view", inputs: ["menuClass", "displayMode", "locales", "locale", "showCountry"], outputs: ["change"] }, { kind: "pipe", type: i3.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: LocaleSelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: "smallstack-locale-selector", changeDetection: ChangeDetectionStrategy.OnPush, template: "<locale-selector-view\n  [menuClass]=\"menuClass\"\n  [locale]=\"localeService.currentLocale$ | async\"\n  [locales]=\"locales\"\n  (change)=\"selectLocale($event)\"\n  [displayMode]=\"displayMode\"\n  [showCountry]=\"showCountry\"\n></locale-selector-view>\n" }]
        }], ctorParameters: function () { return [{ type: i1.LocaleService }]; }, propDecorators: { locales: [{
                type: Input
            }], showCountry: [{
                type: Input
            }], menuClass: [{
                type: Input
            }], displayMode: [{
                type: Input
            }], selectedLocale: [{
                type: Output
            }] } });
